/**
 * [V]:The reason for doing this, is that when we import <Toolbar> we don't want to have to import all other components
 * so that we can use the <Toolbar> component - we should only import a component and that component should be good
 * to go out of the box.
 */
import Toolbar from "./toolbar.js";
import TabMenu from "../../core/tab-menu/index.js";
import Menu from "../../core/menu/index.js";
import Header from "../../core/header/header";
Toolbar.TabMenu = TabMenu;
Toolbar.Menu = Menu;
Toolbar.Header = Header;
export default Toolbar;
//# sourceMappingURL=index.js.map